import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, getPaymentProcessorTitle, toast } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import SecureAndPayCreateModal from 'modules/profile/payment-gateways/integrations/secure-and-pay/components/secure-and-pay-create-modal';
import { getConnectionWebhookBaseUrl } from 'modules/profile/payment-gateways/integrations/secure-and-pay/constants';
import { useSecureAndPayRestApi } from 'modules/profile/payment-gateways/integrations/secure-and-pay/hooks';
import { SecureAndPayPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/secure-and-pay/types';
import { getSecureAndPayHelpPageLink } from 'modules/profile/payment-gateways/integrations/secure-and-pay/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon } from '@systemeio/ui/icons';
import Image from 'next/image';
import SapLogo from '../../../../../../public/images/sap-logo.png';
export const SecureAndPay: FC = () => {
  const $ = _c(6);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.SecureAndPay
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const secureAndPayIntegration = t0;
  const title = getPaymentProcessorTitle(PaymentProcessorEnum.SecureAndPay);
  const {
    disconnect
  } = useSecureAndPayRestApi();
  const onDelete = async () => {
    await disconnect();
    await removePaymentIntegration({
      processor: PaymentProcessorEnum.SecureAndPay
    });
    toast.success(t("dashboard.settings.payment-gateways.account_removed", {
      payment: title
    }));
  };
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getConnectionWebhookBaseUrl();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const connectionWebhookUrl = `${t1}/${user?.slug}`;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={SapLogo} width={150} height={50} alt="Secure & Pay" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = user?.dashboardLocale;
  let t4;
  if ($[4] !== t3) {
    t4 = getSecureAndPayHelpPageLink(t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return <Integration logo={t2} additionalInfo={<a className="primary-link" href={t4} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
      integration: title
    }} /></a>}>{secureAndPayIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!secureAndPayIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}{secureAndPayIntegration.details.siteId && <div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.site_id")}:`}</span><span className="text-text-primary truncate">{secureAndPayIntegration.details.siteId}</span></div>}<div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.webhook_url")}:`}</span><span className="text-text-primary truncate">{connectionWebhookUrl}</span><CopyToClipboardButton text={connectionWebhookUrl} /></div></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
        payment: title
      })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
        payment: title
      })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.secure_and_pay")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <SecureAndPayCreateModal />}</Integration>;
};